export enum PermissionProfileOption {
  PROFILE_COMMON_LOGIN = 'mi-perfil',
  PROFILE_MANAGE_BASIC_INFORMATION = '/mi-perfil/informacion-basica',
}
